// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";

import sharedActionCreators from "@modules/shared/actionCreator";
import * as sharedSelectors from "@modules/shared/selectors";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyAssignment } from "@modules/service/types";
import type { StepProps } from "@components";

type PropsFromState = $Exact<{
  hierarchy: ?HierarchyTree,
  assignments: Array<HierarchyAssignment>,
}>;

type PropsFromDispatch = $Exact<{
  setAssignments: typeof actionCreators.SetWellbeingServiceAssignments,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step2Assignments extends React.Component<Props> {
  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.props.setAssignments(data);
  };

  render() {
    if (!this.props.editable) {
      return null;
    }

    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          {this.props.hierarchy && this.props.assignments ? (
            <HierarchyScopeForm
              hierarchy={this.props.hierarchy}
              assignments={this.props.assignments}
              onChange={this.handleChanges}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    hierarchy: sharedSelectors.getHierarchyTree(state),
    assignments: serviceSelectors.getManagerSmsAssignments(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setAssignments: actionCreators.SetManagerSmsNotificationAssignments,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step2Assignments);
